import { useEffect } from 'react';
import { removeAllGlobalStyles } from '../utils/globalStyles';
import { useLoadFontStyles } from '../../../hooks/fonts/useLoadFontStyles';
import { useLoadGlobalStyles } from '../../../hooks/useLoadGlobalStyles';
export const StylesLoader = ({
  fields,
  globalStyles
}) => {
  const {
    loadCssVarMap
  } = useLoadGlobalStyles({
    fields,
    globalStyles
  });
  const {
    fontsToLoad,
    loadFontStyles
  } = useLoadFontStyles({
    fields,
    globalStyles
  });
  useEffect(() => {
    for (const font of fontsToLoad) {
      void loadFontStyles(font);
    }
    loadCssVarMap(globalStyles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    return () => {
      removeAllGlobalStyles();
    };
  }, []);
  return null;
};